module.exports = __webpack_public_path__ + "img/pic6.84f8e5da.png";